<!-- NOTICE: KAPTION-INTEGRATION -->
<script setup>
import { computed } from 'vue';
import FluentIcon from 'shared/components/FluentIcon/Index.vue';

const props = defineProps({
  icon: {
    type: Object,
    default: () => ({}),
  },
  title: {
    type: String,
    default: '',
  },
  size: {
    type: [String, Number],
    default: 20,
  },
});

const hasIcon = computed(() => {
  return props.icon?.type && props.icon?.value;
});

const letterFallback = computed(() => {
  return props.title ? props.title.charAt(0).toUpperCase() : 'A';
});

const iconSizeClass = computed(() => {
  const numSize = Number(props.size);
  // Map to Tailwind text size classes
  if (numSize <= 12) return 'text-xs';
  if (numSize <= 14) return 'text-sm';
  if (numSize <= 16) return 'text-base';
  if (numSize <= 18) return 'text-lg';
  if (numSize <= 20) return 'text-xl';
  if (numSize <= 24) return 'text-2xl';
  return 'text-3xl';
});
</script>

<template>
  <span class="dashboard-app-icon inline-flex items-center justify-center">
    <!-- Emoji icon -->
    <span
      v-if="hasIcon && icon.type === 'emoji'"
      class="emoji-icon leading-none"
      :class="iconSizeClass"
    >
      {{ icon.value }}
    </span>

    <!-- SVG icon -->
    <FluentIcon
      v-else-if="hasIcon && icon.type === 'icon'"
      :icon="icon.value"
      :size="size"
      class="flex-shrink-0"
    />

    <!-- Letter fallback -->
    <span
      v-else
      class="letter-fallback font-semibold text-current leading-none"
      :class="iconSizeClass"
    >
      {{ letterFallback }}
    </span>
  </span>
</template>

<style scoped>
.dashboard-app-icon {
  @apply leading-none;
}
</style>
